/** "On Triggers" → "On triggers": the cadence names, sentence case. */
export const sentenceCase = (t) =>
  typeof t === "string" && t ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t;
